import { GlowBlob } from "../../../ui/waq/GlowBlob";
import { SectionHairline } from "../../../ui/waq/SectionHairline";
import { CallScheduler } from "./CallScheduler";
import { BriefForm } from "./BriefForm";
import { bookSection } from "../../../../content/waq/book";

/**
 * design/Homepage.dc.html lines 424-461.
 *
 * Two ways in, side by side: pick a slot in our calendar (see CallScheduler),
 * or describe the problem in the brief (see BriefForm) and let an engineer come
 * back to you. Both are live — the brief posts to the same endpoint as the
 * contact form.
 *
 * This file is the layout and the copy around them; the behaviour is in the two
 * components it composes.
 */
export function BookACall() {
  return (
    <section id="book" className="bg-field" aria-labelledby="book-heading">
      <SectionHairline />

      {/* Columns stretch rather than start, so the scheduler panel runs to the
          same depth as the form beside it. */}
      <div className="mx-auto grid max-w-container grid-cols-[repeat(auto-fit,minmax(min(400px,100%),1fr))] gap-2col px-section-x py-light-2col-y">
        <div className="flex flex-col motion-safe:animate-rise">
          <p className="mb-3.5 text-eyebrow font-extrabold uppercase text-blue">
            {bookSection.eyebrow}
          </p>
          <h2 id="book-heading" className="mb-7 text-h2-light font-extrabold">
            {bookSection.heading}
          </h2>

          {/* The lead moves inside the panel. It is the offer, so it belongs
              with the thing that accepts it — and it gives the panel something
              to hold besides a button in an empty white box. */}
          <div className="relative flex flex-1 flex-col justify-center overflow-hidden rounded-panel bg-navy p-9 text-surface shadow-dark-panel">
            <GlowBlob
              position={{ top: -170, right: -130 }}
              size={560}
              alpha={0.34}
              falloff="62%"
              animated
              duration="slow"
            />

            <div className="relative">
              <span
                aria-hidden="true"
                className="mb-7 block h-1 w-14 rounded-pill bg-yellow"
              />
              <p className="mb-9 max-w-[440px] text-lead text-ondark-body">
                {bookSection.lead}
              </p>

              <CallScheduler />
            </div>
          </div>
        </div>

        <BriefForm />
      </div>
    </section>
  );
}
